/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
var _abi = [
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var IBeacon__factory = /** @class */ (function () {
    function IBeacon__factory() {
    }
    IBeacon__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    IBeacon__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    IBeacon__factory.abi = _abi;
    return IBeacon__factory;
}());
export { IBeacon__factory };
